module.exports = __webpack_public_path__ + "static/media/dgl1.png.dc94c08b.jpg";